var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"menu-item",class:{
    'menu-item--current': _vm.isCurrent,
    disabled: _vm.disabled
  },attrs:{"href":_vm.link,"target":"_blank"},on:{"click":_vm.openLink}},[_vm._t("default"),_c('div',{staticClass:"menu-item-content"},[_vm._v(" "+_vm._s(_vm.name)+" "),(!_vm.disabled)?_c('img',{staticClass:"menu-item__icon",attrs:{"src":require("@/assets/global-icons/arrow-right-white.svg")}}):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }